import { User } from '../../models/user.types';
import { Cart } from '../../models/cart.types';

export const friendBuyPurchaseEvent = (user: User, cart: Cart): void => {
  if (window.friendbuyAPI) {
    window.friendbuyAPI.push([
      'track',
      'purchase',
      {
        id: user.subscriptionId.toString(),
        amount: parseFloat(cart.priceSummary.total.toString()
          .replace(/[^0-9.]/g, '') || '0'),
        currency: 'USD',
        customer: {
          id: user.id.toString(),
          email: user.email,
        },
      },
    ]);
  }
};
